module.exports = __webpack_public_path__ + "static/js/2.7d44d868.chunk.worker.js"